export default {
  // Посчитаем?
  calculate_title: 'Посчитаем?',
  gold_content: 'Проба золота:',
  gold_weight_grams: 'Вес золота, грамм:',
  gold_weight_exceed: 'Вес золота не может превышать',
  gram_text: 'грамм',
  gram: 'грамм',
  loan_term_days: 'Срок микрокредита, дни:',
  loan_term_exceed: 'Срок займа не может превышать',
  days_text: 'дней',
  days: 'дней',
  amount_on_hand: 'Сумма на руки:',
  refund_amount: 'Сумма к возврату:',
  // Экспресс-продление
  expressExtension: 'Экспресс-оплата',
  iin: 'ИИН',
  enter_iin: 'Введите ваш ИИН',
  number_zb: 'Номер залогового билета',
  enter_zb: 'Введите номер залогового билета',
  extent_loan: 'Продлить микрокредит',
  express_text1: 'В любой момент вы можете продлить <br> заем в личном кабинете, а также <br> получить полную информацию <br> о всех своих займах.',
  something_went_wrong: 'Что-то пошло не так',
  express_text2: 'ИИН или Номер Залогового билета <br> не верные, следует повторить.',
  service_unavailable: 'Сервис временно недоступен. Попробуй позже.',
  enter_term: 'или введите срок вручную',
  total_payment: 'Итого к оплате:',
  pay: 'Оплатить',
  express_text3: 'Кажется, в процесс вкралась ошибка. <br> Может, еще разок?',
  loan_successfully_extended: 'Заем успешно продлен',
  super: 'Супер!',
  view_receipt: 'Посмотреть квитанцию',
  tg: 'тг',
  // Загляни к нам
  office_radius: 'Ближайший к вам офис в радиусе',
  km: 'км',
  all: 'Все',
  are_you_here: 'Ты здесь',
  // Пообщаемся?
  contact_you: 'Как к тебе обращаться?',
  nickname_yourself: 'Возьми себе прозвище',
  nickname: 'Мадонна Луиза Вероника Чикконе',
  call_you: 'Куда тебе позвонить?',
  write_me: 'Напиши мне, напиши',
  message_text: 'Текст сообщения',
  send: 'Отправить',
  modal_error1: 'Заполните имя или воспользуйтесь генератором имен.',
  modal_error2: 'Что-то не так с номером.. Введен не верный номер.',
  modal_error3: 'Введите адрес электронной почты и контактный номер.',
   modal_error3_1: 'Введите адрес электронной почты',
  modal_error4: 'Что-то не так с адресом.. Введен не верный адрес.',
  modal_error5: 'При вводе электронной почты, нужно обязательно заполнить текст сообщения.',
  modal_error6: 'Будем на связи! Скоро перезвоним!',
  // title
  rules_title: 'Без правил никуда!',
  online_rules_title: 'Правила online операций',
  location_title: 'Загляни к нам',
  form_title: 'Пообщаемся?',
  qa_title: 'Часто задаваемые вопросы',
  // admin
  to_come_in: 'Войти',
  registration: 'Зарегистрироваться',
  personal_cabinet: 'Личный кабинет',
  password: 'Пароль',
  enter_password: 'Введите ваш пароль',
  login: 'Войти',
  number_phone: 'Номер телефона',
  forgot_password: 'Забыли пароль?',
  signup: 'Зарегистрироваться',
  login_a: 'Авторизация',
  check_in: 'Регистрация',
  code: 'Получить код',
  sms_code: 'СМС код',
  further: 'Далее',
  fpassword_text: 'Отправить код снова можно будет <br> через',
  seconds: 'секунд',
  send_code_again: 'Отправить код снова',
  new_password: 'Новый пароль',
  repeat_new_password: 'Повторите новый пароль',
  enter_new_password: 'Введите ваш новый пароль',
  enter_repeat_new_password: 'Введите ваш новый пароль повторно',
  save: 'Сохранить',
  ent_password:'Укажите пароль',
  ent_your_password: 'Укажите ваш пароль',
  rep_password:'Повторите пароль',
  re_enter_your_password:'Укажите ваш пароль повторно',
  back: 'Назад',
  // админ меню
  my_loans: 'Мои займы',
  express_renewal: 'Экспресс оплата',
  my_last_operations: 'Мои последние операции',
  valuation_capital: 'Оценка моего капитала',
  notification_history: 'История уведомлений',
  change_details: 'Изменить мои данные',
  change_password: 'Изменить мой пароль',
  exit: 'Выход',
  // Мои займы
  security_ticket: 'Залоговый билет',
  guaranteed_time_green: 'Срок займа',
  guaranteed_time_yellow: 'Гарантированный срок ожидания',
  guaranteed_time_orange: 'Истекает гарантированный срок ожидания',
  guaranteed_time_red: 'Истек гарантированный срок ожидания',
  loan_balance: 'Остаток суммы займа',
  on_loan: '% по займу',
  for_delay:'% за просрочку',
  interest_payable: 'Проценты к оплате',
  in_detail: 'Подробно',
  pay_for_renewal:'Оплачиваю за услуги продления',
  for_partial_repayment:'Оплачиваю за услуги частичного погашения',
  change_operation_parameters: 'Изменить параметры операции',
  hide: 'Скрыть',
  partial_repayment: 'Услуги частичного погашения',
  renewal: 'Услуги продления',
  new_loan_term:'Новый срок займа:',
  remuneration_amount: 'Сумма вознаграждения:',
  partial_redemption_amount: 'Сумма частичного <br> погашения, к оплате:',
  from: 'от',
  before: 'до',
  balance_loan_amount: 'Остаток суммы займа <br> после оплаты:',
  to_apply: 'Применить',
  how_many_days: 'Сколько дней оплачиваю:',
  new_term:'Новый срок:',
  pay_loan_extension: 'Оплачиваю за услуги продления:',
  pay_loan_partial_repayment: 'Оплачиваю за услуги частичного погашения займа',
  branch: 'Филиал',
  loan_term: 'Срок займа',
  guaranteed_term: 'Гарантированный срок',
  which_loan: 'из них: % по займу',
  total_return:'Всего к возрату',
  name: 'Наименование',
  description: 'Описание',
  edit: 'Редактировать',
  product_description: 'Описание изделия',
  products: 'Изделия',
  probe: 'Проба',
  weight: 'Вес, гр',
  content: 'Содержание',
  gr: 'гр',
  pay_total: 'Оплатить всего',
  add_description: 'Добавить описание',
  // Мои последние операции
  order_number: 'Номер заказа',
  date_and_time: 'Дата и время',
  place_operation: 'Место операции',
  operation: 'Операция',
  transaction_amount: 'Сумма операции',
  status: 'Статус',
  receipt: 'Квитанция',
  total_amount: 'Итоговая сумма',
  held: 'Проведен',
  canceled: 'Отменено',
  text_operation: 'Здесь будут отображаться Ваши операции по залоговым билетам',
// Оценка моего капитала
  title_o: 'Название',
  img: 'Изображение',
  product_weight:'Вес изделия',
  getting_hands:'Получаю <br> на руки',
  add_item:'Добавить изделие',
  total:'Итого',
  add_item_2:'Добавление изделия',
  product_name:'Наименование изделия',
  product_your_name:'Наименование вашего изделия',
  add: 'Добавить',
  today: 'Сегодня',
  text_1: 'я могу получить в МК-Золото',
  text_2: 'за мои ранее выкупленные изделия',
  // Изменить мои данные
  fio: 'ФИО',
  date_birth:'Дата рождения',
  text_3: 'Для изменения личных данных обратитесь в филиал, <br> предоставив документ удостоверяющий личность',
  change:'Изменить',
  new_phone:'Новый контактный номер',
  complete:'Завершить',
  your_number_changed:'Ваш номер был изменен',
  new_e_mail_address:'Новый e-mail адрес',
  your_mail_changed:'Ваша почта была изменена',
  // Изменить мой пароль
  current_password:'Текуший пароль',
  enter_current_password:'Введите текуший пароль',
  enter_new_password1:'Введите новый пароль',
  new_password_again:'Новый пароль повторно',
  re_enter_new_password:'Введите новый пароль повторно',
  password_error:'Пароль и повторный пароль не совпадает',
  // Смена аватарки
  mbErrorText: 'Размер изображения не должен превышать 10 мб',
  avatar_change: 'Смена аватарки',
  upload_image: 'Загрузить изображение',
  take_avatars:'Возьми себе одну из наших аватарок',
  text_zd: 'Здесь будут отображаться Ваши залоговые билеты',
  // договор
  check_contract: 'Проверить договор',
  check_contract2: 'Твой договор',
  check_contract3: 'Твой электронный договор',
  contract_code: 'Код',
  contract_text: 'Код выдается в офисе компании на бумажном носителе',
  enter_contract_code: 'Введите ваш код',
  verify: 'Получить',
  confirmation: 'Подтверждение',
  contract_text2: 'С условиями договора и сохранной квитанции',
  read_and_agree: 'Ознакомлен и согласен',
  conservation_receipt: 'Сохранная квитанция',
  shelf_life: 'Срок хранения',
  keep_price: 'Плата за хранение',
  loan_expired: 'Просрочен',
  message_text_loan: 'Внимание! <br> Для выбранного займа необходимо заключить договор хранения в любом филиале.',
  login_t: 'Логин',
  login_placeholder: 'Введите ваш логин',
  login_text: 'Логин и код выдаются в офисе компании на бумажном носителе',
  message_no_text: 'Проведение операции невозможно. <br> Просим Вас прийти в филиал',
  pay_saved_card: 'Оплатить с помощью сохраненной карты?',
  add_payment_card: 'Добавить карту',
  confirm_card_remove: 'Подтвердите удаление карты',
  card_empty: 'Список сохраненных карт пуст',
  pay_with_card_success: 'Оплата принята'
}



// WEBPACK FOOTER //
// ./src/lang/ru.js